import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import InputField from "../../../components/inputField";
import Page from "../../../components/Page";
import { backendUrl } from "../../../constants";
import "./styles.css";

const Index = ({ links, setLinks, defaultLinks }) => {
  const [linkType, setLinkType] = useState({});

  //linkType
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/weblinks`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          setLinkType((inds) => ({ ...inds, [obj.lookupName]: obj._id }));
        });
      })
      .catch((err) => console.error(err));
  }, []);

  const onChangeLink = (v, linkType) => {
    let newData = {
      linkType: linkType,
      linkURL: v.target.value,
    };
    let found = false;
    links.weblinks?.map((obj, key) => {
      if (obj?.linkType === linkType) {
        links.weblinks[key] = newData;
        found = true;
        setLinks((links) => ({
          ...links,
          weblinks: [...links.weblinks],
        }));
      }
    });
    !found &&
      setLinks((links) => ({
        ...links,
        weblinks: [...links.weblinks, newData],
      }));
  };

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="link-main">
        <h2 className="text-dark text-center">Company Social Links</h2>
        <InputField
          placeholder={"Google"}
          icon="Google"
          value={defaultLinks.Google}
          onChange={(v) => onChangeLink(v, linkType?.Google)}
        />
        <InputField
          placeholder={"Facebook"}
          icon="Facebook"
          value={defaultLinks.Facebook}
          onChange={(v) => onChangeLink(v, linkType?.Facebook)}
        />
        <InputField
          placeholder={"Twitter"}
          icon="Twitter"
          value={defaultLinks.Twitter}
          onChange={(v) => onChangeLink(v, linkType?.Twitter)}
        />
        <InputField
          placeholder={"LinkedIn"}
          icon="LinkedIn"
          value={defaultLinks.LinkedIn}
          onChange={(v) => onChangeLink(v, linkType?.LinkedIn)}
        />
        <InputField
          placeholder={"Youtube"}
          icon="Youtube"
          value={defaultLinks.Youtube}
          onChange={(v) => onChangeLink(v, linkType?.Youtube)}
        />
        <InputField
          placeholder={"Instagram"}
          icon="Instagram"
          value={defaultLinks.Instagram}
          onChange={(v) => onChangeLink(v, linkType?.Instagram)}
        />
        <InputField
          placeholder={"Website"}
          icon="Website"
          value={defaultLinks.Website}
          onChange={(v) => onChangeLink(v, linkType?.Website)}
        />
        <InputField
          placeholder={"Discord"}
          icon="Discord"
          value={defaultLinks.Discord}
          onChange={(v) => onChangeLink(v, linkType?.Discord)}
        />
        <InputField
          placeholder={"Slack"}
          icon="Slack"
          value={defaultLinks.Slack}
          onChange={(v) => onChangeLink(v, linkType?.Slack)}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
